import React, { useState } from 'react';
import { Box, Button, Tab, Tabs, TextField, Typography, Paper, IconButton } from '@mui/material';
import Grid from "@mui/material/Grid2";
import Swal from "sweetalert2";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getAnalystReport } from 'src/shared/util/requestDataServer';
import DownloadIcon from '@mui/icons-material/Download';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import SearchIcon from '@mui/icons-material/Search';

import './styles.scss'
import { downloadExcelFormatAnalyst } from 'src/shared/util/downloadExcel';
import moment from 'moment';

export interface SummaryResponse {
    totalLocations: number,
    totalActivitiesShouldBeAnalyzed: number,
    totalActivitiesAnalyzed: number,
    summaryByDate: any[],
    summaryByUser: any[]
}

export const ReportManager = ({ setloading, goBack }: { setloading: any, goBack: any }) => {
    const [tab, setTab] = useState(0);
    const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);

    const [data, setData] = useState<SummaryResponse | undefined>(undefined);

    const [detailData, setDetailData] = useState<any[]>([])

    const [viewDetailed, setViewDetailed] = useState(false)

    const handleRequestData = () => {
        if (!startDate || !endDate) {
            Swal.fire({
                icon: "warning",
                title: "Fechas Inválidas",
                text: "Por favor, seleccione un rango de fechas válido.",
            });
            return;
        }

        setloading(true);

        getAnalystReport(startDate, endDate).then((response) => {
            if (response) {

                console.log({ response })

                setData(response);
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "No se encontraron datos para el rango de fechas seleccionado.",
                });
            }
        }).finally(() => {
            setloading(false);
        });
    };

    const handleViewDetailed = (data: any[]) => {
        setDetailData(data);
        setViewDetailed(true);
        setTab(0);
    }

    const handleCloseDetailes = () => {
        setViewDetailed(false);
        setDetailData([]);
        setTab(0);
    }

    const handleBackToDateSelection = () => {
        setData(undefined);
        setTab(0);
    };

    const handleDownloadExcel = async () => {
        if (!startDate || !endDate) {
            Swal.fire({
                icon: "warning",
                title: "Fechas Inválidas",
                text: "Por favor, seleccione un rango de fechas válido.",
            });
            return;
        } else {
            setloading(true);
            downloadExcelFormatAnalyst(startDate, endDate).finally(() => {
                setloading(false);
            });

        }
    }

    const columnsSummary: GridColDef[] = [
        { field: "date", headerName: "Fecha de Adquisicion", hideable: true, flex: 1 },
        { field: "activitiesExecutedByField", headerName: "Activiades totales", flex: 1 },
        { field: "activitiesShouldBeAnalyzed", headerName: "Activiades a analizar", flex: 1 },
        { field: "activitiesAnalyzed", headerName: "Activiades analizadas", flex: 1 },
        { field: "activitiesAssignedToUsers", headerName: "Activiades asignadas", flex: 1 },
        {
            field: "activitiesNotAnalyzed", headerName: "Activiades no analizadas", flex: 1, renderCell: (params) => {
                return (
                    <Grid sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                        <Typography variant="body2" color="textSecondary">
                            {params.value}
                        </Typography>
                        {params.value > 0 && (
                            <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleViewDetailed(params.row.activityDetailsForDate)}
                            >
                                <SearchIcon fontSize="medium" />
                            </IconButton>
                        )}

                    </Grid>
                );
            }
        }
    ];

    const columnsSummaryDetail: GridColDef[] = [
        { field: "id", headerName: "ID", hideable: true, },
        { field: "adquisitionDate", headerName: "Fecha de Adquisicion", hideable: true, flex: 0.6, renderCell: (params) => {
            const adquisitionDate = params.row.adquisitionDate
                ? moment(params.row.adquisitionDate).local().format('DD-MMM-YY')
                : '';
            return (
                <Typography variant="body2" sx={{
                    height: '100%',
                    display: 'flex',
                    textWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                }}>
                    {adquisitionDate}
                </Typography>
            );
        }},
        {
            field: "expectedAnalyzedDate", headerName: "Fecha de analisis esperada", hideable: true, flex: 0.6, renderCell: (params) => {
                const expectedDate = params.row.expectedAnalyzedDate
                    ? moment(params.row.expectedAnalyzedDate).local().format('DD-MMM-YY')
                    : '';
                return (
                    <Typography variant="body2" sx={{
                        height: '100%',
                        display: 'flex',
                        textWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }}>
                        {expectedDate}
                    </Typography>
                );
            }
        },
        {
            field: "analyzedDate", headerName: "Fecha analizado", flex: 0.6, renderCell: (params) => {
                const analyzedDate = params.row.analyzedDate
                    ? moment(params.row.analyzedDate).local().format('DD-MMM-YY HH:mm')
                    : 'No analizado';
                return (
                    <Typography variant="body2" sx={{
                        height: '100%',
                        display: 'flex',
                        textWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                    }}>
                        {analyzedDate}
                    </Typography>
                );
            }
        },
        { field: "name", headerName: "Pozos", flex: 1 },
        { field: "activity", headerName: "Actividad", flex: 1 },
        { field: "assignedAnalyzerUser", headerName: "Asignado a" },
        { field: "analyzed", headerName: "Analizado", type: 'boolean' },
        { field: "dyn", headerName: "Carta", type: 'boolean' },
        { field: "liquidLevel", headerName: "Nivel de Líquido", type: 'boolean' },
    ];

    return (
        <Box className="report-manager-root">
            {/* Section 1: Date selection */}
            {!data && (
                <Paper className="date-section" elevation={2}>
                    <Grid className="title-section">
                        <IconButton onClick={goBack}>
                            <ArrowBackIcon />
                        </IconButton>
                        <Typography variant="h6" gutterBottom>
                            Seleccione Rango de Fechas
                        </Typography>
                    </Grid>
                    <Grid container spacing={2} alignItems="center">
                        <Grid>
                            <TextField
                                label="Fecha Inicio"
                                type="date"
                                size="small"
                                value={startDate}
                                onChange={e => setStartDate(e.target.value)}
                                slotProps={{ inputLabel: { shrink: true } }}
                            />
                        </Grid>
                        <Grid>
                            <TextField
                                label="Fecha Fin"
                                type="date"
                                size="small"
                                value={endDate}
                                onChange={e => setEndDate(e.target.value)}
                                slotProps={{ inputLabel: { shrink: true } }}
                            />
                        </Grid>
                    </Grid>
                    <Grid>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleRequestData}
                        >
                            Solicitar Datos
                        </Button>
                    </Grid>
                </Paper>
            )}

            {/* Section 2: Tabs */}
            {data && (
                <Paper className="tabs-section" elevation={2}>
                    <Grid>
                        <Tabs
                            value={tab}
                            className="tabs_Section"
                            onChange={(_, newValue) => setTab(newValue)}
                            variant='fullWidth'
                        >
                            <Tab label="Resumen" />
                            <Tab label="Detalles" />
                        </Tabs>
                    </Grid>
                    <Grid className="title-report-section">
                        <IconButton onClick={handleBackToDateSelection}>
                            <ArrowBackIcon sx={{ color: "white" }} />
                        </IconButton>

                        <Typography>
                            Actividades en el periodo
                            <span className="date_text">
                                {startDate
                                    ? `${startDate.slice(8, 10)}/${startDate.slice(5, 7)}/${startDate.slice(0, 4)}`
                                    : ""}
                            </span>
                            al
                            <span className="date_text">
                                {endDate
                                    ? `${endDate.slice(8, 10)}/${endDate.slice(5, 7)}/${endDate.slice(0, 4)}`
                                    : ""}
                            </span>
                        </Typography>
                        <IconButton
                            onClick={() => handleDownloadExcel()}
                            size='small'
                            sx={{
                                backgroundColor: "#1976d2", // MUI primary blue
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#1565c0", // darker blue on hover
                                },
                            }}
                        >
                            <DownloadIcon />
                        </IconButton>

                    </Grid>
                    <Grid className="sub-title-report-section">
                        <Typography variant="subtitle1" sx={{ color: "white" }}>
                            Total de pozos con estudios <span className="date_text">{data.totalLocations}</span>
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: "white" }}>
                            Total de actividades para analisis <span className="date_text">{data.totalActivitiesShouldBeAnalyzed}</span>
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: "white" }}>
                            Total de actividades analizadas <span className="date_text">{data.totalActivitiesAnalyzed}</span>
                        </Typography>
                    </Grid>

                    <Box className="tab-content">
                        {/* Seccion Resumen */}
                        {tab === 0 && (
                            <Grid>
                                {viewDetailed && (
                                    <Grid className="close_details_sections">
                                        <IconButton onClick={handleCloseDetailes} size="small">
                                            <ArrowBackIcon sx={{ color: "white" }} />
                                            <Typography fontSize={15} sx={{ color: "white" }}>
                                                Cerrar detalles
                                            </Typography>
                                        </IconButton>
                                    </Grid>
                                )}
                                <DataGrid
                                    rows={(viewDetailed ? detailData : data?.summaryByDate) || []}
                                    columns={viewDetailed ? columnsSummaryDetail : columnsSummary}
                                    pageSizeOptions={[10, 20, 50, 100]}
                                    checkboxSelection={false}
                                    initialState={{
                                        columns: {
                                            columnVisibilityModel: {
                                                id: false, // Hide the 'id' column
                                            }
                                        },
                                        sorting: {
                                            sortModel: [
                                                { field: 'date', sort: 'desc' }
                                            ]
                                        }
                                    }}
                                    sx={{
                                        border: 0,
                                        "& .MuiDataGrid-columnHeader": {
                                            backgroundColor: "#03365E",
                                            color: "#fff",
                                            fontWeight: "bold",
                                        },
                                        "& .MuiDataGrid-columnHeaderTitle": {
                                            whiteSpace: "pre-line !important",
                                            textAlign: "center",

                                        },
                                        maxHeight: '50vh',
                                    }}
                                    getRowId={(row) => row.id || row.date}
                                />
                            </Grid>
                        )}
                        {/* Seccion Detalles */}
                        {tab === 1 && (
                            <Grid className="report_details">
                                <Grid className="report_details_header">
                                    <Grid className="element">Ingeniero</Grid>
                                    <Grid className="element">Plan</Grid>
                                    <Grid className="element">Real</Grid>
                                    <Grid className="element">%</Grid>
                                    <Grid className="last-element">Observación</Grid>
                                </Grid>
                                {data?.summaryByUser && data.summaryByUser.length > 0 && (
                                    <Grid className="report_body_section">
                                        {data.summaryByUser.slice().reverse().map((row, index) => (
                                            <Grid key={index}>
                                                <Grid key={index} className="row_report_line">
                                                    <Grid className="row_element">{row.user}</Grid>
                                                    <Grid className="row_element">{row.totalActivitiesShouldBeAnalyzed}</Grid>
                                                    <Grid className="row_element">{row.totalActivitiesAnalyzed}</Grid>
                                                    <Grid className="row_element">{row.average} %</Grid>
                                                    <Grid className="row_element"></Grid>
                                                </Grid>
                                                {row?.datesOfWork?.map((item: any, index2: number) => (
                                                    <Grid key={`${item.date}-${row.user}`} className="row_report_sub_line">
                                                        <Grid className="row_sub_element">
                                                            {item.date
                                                                ? new Date(item.date + 'T00:00:00').toLocaleDateString('es-ES', {
                                                                    day: '2-digit',
                                                                    month: 'short',
                                                                    year: '2-digit'
                                                                }).replace('.', '')
                                                                : ''}
                                                        </Grid>
                                                        <Grid className="row_sub_element">{item.plan}</Grid>
                                                        <Grid className="row_sub_element">{item.real}</Grid>
                                                        <Grid className="row_sub_element">{item.average} %</Grid>
                                                        <Grid className="row_sub_element">{item.comment}</Grid>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        ))}
                                    </Grid>
                                )}
                            </Grid>
                        )}
                    </Box>
                </Paper>
            )}
        </Box>
    );
};
